/**
 * @param {HTMLElement} vatinValueControl
 * @param {boolean} enable
 */
const setVatinValueState =
  (vatinValueControl, enable) => {
    [
      ['disabled', true],
      ['hidden', true],
      ['readonly', true],
      ['required', false],
    ].forEach(([attr, invert]) => {
      if (enable ^ invert) {
        vatinValueControl.setAttribute(attr, attr)
        vatinValueControl.parentElement.classList.add(`-is-${attr}`)
      } else {
        vatinValueControl.removeAttribute(attr)
        vatinValueControl.parentElement.classList.remove(`-is-${attr}`)
      }
    })
  }

/**
 * @param {HTMLElement} vatinValueControl
 */
const onChangeVatinHas =
  (vatinValueControl) =>
/**
 * @param {Event} event
 */
  (event) => {
    if ('0' === event.target.value) {
      setVatinValueState(vatinValueControl, false)
    } else if ('1' === event.target.value) {
      setVatinValueState(vatinValueControl, true)
    } else {
      throw 'Wrong value!'
    }
  }

/**
 * @param {HTMLElement} vatinHasControl
 */
export default (vatinHasControl) => {
  const vatinValueControl = document.getElementById(vatinHasControl.getAttribute('aria-controls'))
  if (vatinHasControl && vatinValueControl) {
    vatinHasControl.addEventListener('change', onChangeVatinHas(vatinValueControl))
  }
}
